/**
 * Live Zone components index - exports all Live Zone components
 * and registers content types on import.
 */
import LiveZone from './LiveZone.mjs';
import LiveZoneRegistry from './LiveZoneRegistry.mjs';
import ScoresTicker from './ScoresTicker.mjs';

// Register content type components
LiveZoneRegistry.register('scores', ScoresTicker);

// Future content types to implement:
// LiveZoneRegistry.register('standings', StandingsWidget);
// LiveZoneRegistry.register('news', NewsHeadlines);
// LiveZoneRegistry.register('stats', StatsWidget);
// LiveZoneRegistry.register('schedule', ScheduleWidget);
// LiveZoneRegistry.register('stream-wall', StreamWall);

export {
    LiveZone,
    LiveZoneRegistry,
    ScoresTicker
};

export default LiveZone;
